import { isPlatformServer } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, PLATFORM_ID, RESPONSE_INIT, inject } from '@angular/core';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { TranslocoDirective } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ButtonComponent]
})
export class NotFoundComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  private responseInit = inject(RESPONSE_INIT, { optional: true });


  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      if (this.responseInit) {
        this.responseInit.status = 404;
      }
    }
  }

  onCtaButtonClicked() {
    location.href = environment.landingUrl;
  }
}
